import { render, staticRenderFns } from "./chart-room-average.vue?vue&type=template&id=3bb028c4&scoped=true&"
import script from "./chart-room-average.vue?vue&type=script&lang=ts&"
export * from "./chart-room-average.vue?vue&type=script&lang=ts&"
import style0 from "./chart-room-average.vue?vue&type=style&index=0&id=3bb028c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb028c4",
  null
  
)

export default component.exports